import { Component } from '@angular/core';
import { AllOffersComponent } from '../../../../components/user-dashboard-component/offers/all-offers-component/all-offers-component';

@Component({
  selector: 'app-all-offers',
  imports: [AllOffersComponent],
  templateUrl: './all-offers.html',
  styleUrl: './all-offers.scss'
})
export class AllOffers {

}
